import { useMapboxSuggestions } from './useMapboxSuggestions';
import { LocationOn } from '@mui/icons-material';
import { useCallback, useEffect } from 'react';
import MapSearchResultItem from '../MapSearchItem';
import { useMapBoxSearchContext } from '../MapSearchBoxContext';
import { useMapSearchBoxPin } from 'components/maps';

export const MapboxSuggestions: React.FC = () => {
  const { searchText } = useMapBoxSearchContext();
  const { suggestions, searchSession } = useMapboxSuggestions({ searchText });
  const { addMapPin, removeMapPin } = useMapSearchBoxPin();

  const onClick = useCallback(
    (suggestion) => {
      const retrievedSuggestion = searchSession.retrieve(suggestion);
      retrievedSuggestion.then((data) => {
        addMapPin(data.features[0].geometry);
      });
    },
    [addMapPin, searchSession]
  );

  useEffect(() => {
    searchText?.length > 0 && removeMapPin();
    // only do this when searchText changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText]);

  const getAdditionalData = (suggestion: any) => {
    const place = suggestion.context?.place?.name ? `${suggestion.context.place.name}, ` : '';
    const region = suggestion.context?.region?.name ? `${suggestion.context.region.name}, ` : '';
    const country = suggestion.context?.country?.country_code_alpha_3 ?? '';
    const data = `${place}${region}${country}`;
    if (data !== '') {
      return data;
    }
  };

  if (!searchText.length) {
    return null;
  }
  return (
    <>
      {suggestions.map((suggestion) => {
        return (
          <MapSearchResultItem
            onClick={() => {
              onClick(suggestion);
            }}
            key={suggestion.mapbox_id}
            name={suggestion.name}
            icon={<LocationOn />}
            additionalData={getAdditionalData(suggestion)}
          />
        );
      })}
    </>
  );
};
